import React from 'react';

const LeadManageTabs = ({activeTab, setActiveTab}) => {

  return (
    <div className={"row-tabs"}>
      <button className={`${activeTab === 1 && "active-tab"}`} onClick={() => setActiveTab(1)}>فهرست لیدها</button>
      <button className={`${activeTab === 2 && "active-tab"}`} onClick={() => setActiveTab(2)}>ثبت پیگیری ها</button>
      <button className={`${activeTab === 3 && "active-tab"}`} onClick={() => setActiveTab(3)}>پرونده</button>
      <button className={`${activeTab === 4 && "active-tab"}`} onClick={() => setActiveTab(4)}>پیگیری</button>
      <button className={`${activeTab === 5 && "active-tab"}`} onClick={() => setActiveTab(5)}>گزارشات</button>
    </div>
  );
};

export default LeadManageTabs;